/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Error_Master_GroupInputs */



/**
* | output |
* | --- |
* | "The priority group must be a production group" |
*
* @param {Cascade_Dialog_Error_Master_GroupInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_error_master_group = /** @type {((inputs?: Cascade_Dialog_Error_Master_GroupInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Error_Master_GroupInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The priority group must be a production group")
	return /** @type {LocalizedString} */ ("Le groupe prioritaire doit être un groupe de production")
});